export const forexBasicsHero = {
  eyebrow: 'Forex พื้นฐาน',
  title: 'เรียน Forex พื้นฐานให้เข้าใจจริง เริ่มได้จากศูนย์',
  description:
    'รวมทุกองค์ความรู้ Forex ที่มือใหม่ต้องรู้ไว้ในที่เดียว ตั้งแต่ตลาด Forex คืออะไร คู่เงินและราคา Bid/Ask ไปจนถึง Pip Spread Leverage Margin และความเสี่ยงที่ควรเข้าใจก่อนเริ่มเทรด',
  primaryCta: 'เริ่มเรียนพื้นฐาน',
  primaryTarget: '#forex-categories',
  secondaryCta: 'ไปที่วิธีเทรด Forex',
  secondaryTarget: '/forex-trading',
  highlights: [
    { icon: 'ri-layout-grid-line', value: '6 หมวด', label: 'ความรู้ที่ต้องรู้' },
    { icon: 'ri-file-list-3-line', value: '30 หัวข้อ', label: 'เรียบเรียงตามลำดับ' },
    { icon: 'ri-exchange-line', value: 'EUR/USD', label: 'ตัวอย่างราคาประกอบ' },
  ],
};

export const forexBasicsLearningPath = [
  {
    no: '01',
    title: 'เข้าใจตลาด Forex',
    desc: 'รู้จักตลาดแลกเปลี่ยนเงินตรา ว่าคืออะไร ทำงานอย่างไร และใครขับเคลื่อนราคา',
    icon: 'ri-global-line',
    link: '#category-intro',
  },
  {
    no: '02',
    title: 'เข้าใจคู่เงินและราคา',
    desc: 'เรียนรู้ว่าคู่เงินอ่านอย่างไร Bid/Ask และอัตราแลกเปลี่ยนหมายถึงอะไร',
    icon: 'ri-exchange-dollar-line',
    link: '#category-price',
  },
  {
    no: '03',
    title: 'เข้าใจคำศัพท์และกลไก',
    desc: 'ทำความเข้าใจ Pip, Lot, Spread, Leverage และ Margin ที่ใช้จริงตอนเทรด',
    icon: 'ri-book-2-line',
    link: '#category-vocab',
  },
  {
    no: '04',
    title: 'เข้าใจความเสี่ยง',
    desc: 'รู้จักความเสี่ยง ต้นทุน และวิธีคิดผลกำไรขาดทุนก่อนก้าวไปเทรดจริง',
    icon: 'ri-shield-check-line',
    link: '#category-risk',
  },
];

export const forexBasicsCategories = [
  {
    id: 'category-intro',
    slug: 'intro',
    featured: true,
    size: 'large',
    title: 'ความรู้เบื้องต้นเกี่ยวกับ Forex',
    desc: 'ปูความเข้าใจก่อนเทรด ว่าตลาด Forex คืออะไร ทำงานอย่างไร มีใครอยู่เบื้องหลังการเคลื่อนไหวของราคา และเปิดทำการเมื่อไหร่',
    icon: 'ri-global-line',
    topics: [
      { label: 'Forex คืออะไร?', to: '/what-is-forex' },
      { label: 'ตลาด Forex ทำงานอย่างไร?', to: '/how-forex-market-works' },
      { label: 'Forex ซื้อขายอะไร?', to: '/what-does-forex-trade' },
      { label: 'ใครเป็นผู้เข้าร่วมในตลาด Forex?', to: '/forex-market-participants' },
      { label: 'ตลาด Forex เปิดทำการกี่โมง?', to: '/forex-market-hours' },
    ],
  },
  {
    id: 'category-price',
    slug: 'price',
    featured: true,
    size: 'large',
    title: 'คู่สกุลเงินและราคา',
    desc: 'อ่านคู่เงินให้เป็น เข้าใจสกุลเงินฐานและสกุลเงินอ้างอิง พร้อมความหมายของราคา Bid, Ask และอัตราแลกเปลี่ยน',
    icon: 'ri-exchange-dollar-line',
    topics: [
      { label: 'คู่เงิน Forex คืออะไร?', to: '/currency-pairs' },
      { label: 'Major, Minor และ Exotic Pairs คืออะไร?', to: '/major-minor-exotic-pairs' },
      { label: 'Base Currency และ Quote Currency คืออะไร?', to: '/base-quote-currency' },
      { label: 'Bid และ Ask คืออะไร?', to: '/bid-and-ask' },
      { label: 'อัตราแลกเปลี่ยนคืออะไร?', to: '/exchange-rate' },
    ],
  },
  {
    id: 'category-vocab',
    slug: 'vocab',
    featured: false,
    size: 'small',
    title: 'คำศัพท์ Forex ที่ควรรู้',
    desc: 'คำศัพท์พื้นฐานที่เจอทุกวันบนแพลตฟอร์มเทรด',
    icon: 'ri-book-2-line',
    topics: [
      { label: 'Pip คืออะไร?', to: '/what-is-pip' },
      { label: 'Point คืออะไร?', to: '/what-is-point' },
      { label: 'Lot คืออะไร?', to: '/what-is-lot' },
      { label: 'Spread คืออะไร?', to: '/what-is-spread' },
      { label: 'Commission คืออะไร?', to: '/what-is-commission' },
    ],
  },
  {
    id: 'category-margin',
    slug: 'margin',
    featured: false,
    size: 'small',
    title: 'Leverage และ Margin',
    desc: 'เข้าใจอำนาจซื้อและเงินประกันที่มาพร้อมกัน',
    icon: 'ri-scales-3-line',
    topics: [
      { label: 'Leverage คืออะไร?', to: '/what-is-leverage' },
      { label: 'Margin คืออะไร?', to: '/what-is-margin' },
      { label: 'Free Margin คืออะไร?', to: '/free-margin' },
      { label: 'Margin Level คืออะไร?', to: '/margin-level' },
      { label: 'Margin Call และ Stop Out คืออะไร?', to: '/margin-call-and-stop-out' },
    ],
  },
  {
    id: 'category-cost',
    slug: 'cost',
    featured: false,
    size: 'small',
    title: 'กำไร ขาดทุน และต้นทุน',
    desc: 'รู้ว่ากำไรขาดทุนคำนวณจากอะไร และมีต้นทุนอะไรบ้าง',
    icon: 'ri-line-chart-line',
    topics: [
      { label: 'กำไรและขาดทุนจาก Forex คำนวณอย่างไร?', to: '/forex-profit-and-loss' },
      { label: 'มูลค่า Pip คืออะไร?', to: '/pip-value' },
      { label: 'Swap คืออะไร?', to: '/what-is-swap' },
      { label: 'Overnight Fee คืออะไร?', to: '/overnight-fee' },
      { label: 'ต้นทุนในการเทรด Forex มีอะไรบ้าง?', to: '/forex-trading-costs' },
    ],
  },
  {
    id: 'category-risk',
    slug: 'risk',
    featured: false,
    size: 'small',
    title: 'ความเสี่ยงที่มือใหม่ควรเข้าใจ',
    desc: 'รู้ทันความเสี่ยงก่อนเสียเงินจริง',
    icon: 'ri-alert-line',
    topics: [
      { label: 'ความเสี่ยงในการเทรด Forex มีอะไรบ้าง?', to: '/forex-risks' },
      { label: 'Leverage สูงมีความเสี่ยงอย่างไร?', to: '/high-leverage-risk' },
      { label: 'Drawdown คืออะไร?', to: '/what-is-drawdown' },
      { label: 'Slippage คืออะไร?', to: '/what-is-slippage' },
      { label: 'ทำไมการเทรด Forex จึงขาดทุนได้?', to: '/why-forex-traders-lose' },
    ],
  },
];

export const forexBasicsQuote = {
  pair: 'EUR/USD',
  bid: '1.08420',
  ask: '1.08428',
  spreadPips: '0.8',
  note: 'ตัวอย่างเพื่อการอธิบาย (Simulated Educational Data) ไม่ได้เชื่อมต่อราคาตลาดจริง',
  definitions: [
    {
      icon: 'ri-arrow-down-line',
      tone: 'accent',
      name: 'Bid',
      thai: 'ราคาที่โบรกเกอร์ซื้อจากเรา',
      desc: 'ใช้เมื่อเราต้องการขาย (Sell) เป็นราคาที่ต่ำกว่าราคา Ask เสมอ',
    },
    {
      icon: 'ri-arrow-up-line',
      tone: 'primary',
      name: 'Ask',
      thai: 'ราคาที่โบรกเกอร์ขายให้เรา',
      desc: 'ใช้เมื่อเราต้องการซื้อ (Buy) เป็นราคาที่สูงกว่าราคา Bid เสมอ',
    },
    {
      icon: 'ri-arrow-left-right-line',
      tone: 'secondary',
      name: 'Spread',
      thai: 'ส่วนต่างระหว่าง Ask และ Bid',
      desc: 'คือต้นทุนแฝงต่อออเดอร์ ทันทีที่เปิดออเดอร์จะเริ่มติดลบเท่ากับ Spread',
    },
  ],
};

export const forexBasicsReviews = [
  {
    id: 'review-market',
    icon: 'ri-global-line',
    title: 'พื้นฐานตลาด Forex',
    question: 'Forex ต่างจากการซื้อหุ้นตรงไหน?',
    answer:
      'Forex ซื้อขายเป็นคู่เงินเสมอ (เช่น EUR/USD) และทำกำไรจากส่วนต่างของราคาโดยไม่ได้ถือสกุลเงินจริง ส่วนหุ้นคือการถือความเป็นเจ้าของบริษัท ตลาด Forex ยังเปิดตลอด 24 ชั่วโมง 5 วันต่อสัปดาห์ด้วย',
    link: '/what-is-forex',
    linkLabel: 'ทบทวนบทความ Forex คืออะไร?',
  },
  {
    id: 'review-spread',
    icon: 'ri-arrow-left-right-line',
    title: 'ราคาและต้นทุน',
    question: 'ทำไมพอเปิดออเดอร์ปุ๊บ ออเดอร์ถึงติดลบทันที?',
    answer:
      'เพราะเราซื้อที่ราคา Ask แต่จะปิดขายที่ราคา Bid ซึ่งต่ำกว่า ผลต่างนี้คือ Spread หรือต้นทุนของออเดอร์ ราคาจึงต้องเคลื่อนที่ผ่าน Spread ไปก่อน ออเดอร์ถึงจะเริ่มเป็นกำไร',
    link: '/what-is-spread',
    linkLabel: 'ทบทวนบทความ Spread คืออะไร?',
  },
  {
    id: 'review-leverage',
    icon: 'ri-scales-3-line',
    title: 'Leverage และความเสี่ยง',
    question: 'Leverage สูงทำให้เสี่ยงมากขึ้นจริงหรือ?',
    answer:
      'Leverage ไม่ได้เพิ่มความเสี่ยงโดยตรง แต่ทำให้คุมสถานะใหญ่ขึ้นได้ด้วยเงินน้อยลง ความเสี่ยงจริงขึ้นอยู่กับขนาดสถานะและระยะ Stop Loss ถ้าใช้สถานะใหญ่เกินพอร์ต Leverage สูงจะทำให้ถูก Margin Call ได้เร็วขึ้น',
    link: '/what-is-leverage',
    linkLabel: 'ทบทวนบทความ Leverage คืออะไร?',
  },
];

export const forexBasicsNextSteps = [
  {
    icon: 'ri-line-chart-line',
    title: 'วิธีเทรด Forex',
    desc: 'ต่อยอดจากพื้นฐานสู่ขั้นตอนเปิดออเดอร์จริง ตั้งแต่เลือกคู่เงิน วิเคราะห์ตลาด กำหนดขนาด ไปจนถึงตั้ง Stop Loss และ Take Profit',
    items: ['เลือกคู่เงิน', 'วิเคราะห์ตลาด', 'กำหนดขนาดการเทรด', 'ตั้ง Stop Loss / Take Profit'],
    to: '/forex-trading',
    cta: 'ไปที่วิธีเทรด Forex',
    accent: true,
  },
  {
    icon: 'ri-computer-line',
    title: 'คู่มือ MT4 / MT5',
    desc: 'เรียนรู้การใช้งานแพลตฟอร์มเทรดยอดนิยม ตั้งแต่ติดตั้ง เปิดกราฟ เพิ่มคู่เงิน ไปจนถึงการเปิดและปิดออเดอร์',
    items: ['ติดตั้งแพลตฟอร์ม', 'เปิดกราฟและเพิ่มคู่เงิน', 'เปิดออเดอร์', 'ตั้ง Stop Loss / Take Profit'],
    to: '/mt4-mt5',
    cta: 'ไปที่คู่มือ MT4 / MT5',
    accent: false,
  },
];